import { FormFieldV2, SearchFieldV2 as SearchField, UnitDropdownV2, AritoIcon, Button } from '@/components/custom/erp';
import { accountSearchColumns, nganHangSearchColumns, QUERY_KEYS } from '@/constants';
import { ACCOUNT_QUICK_CREATE_KEY, BANK_QUICK_CREATE_KEY } from './QuickCreateScope';
import { AccountModel, NganHang } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  nganHang: NganHang | null;
  taiKhoan: AccountModel | null;
  setNganHang: (nganHang: NganHang | null) => void;
  setTaiKhoan: (taiKhoan: AccountModel | null) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
  formMode,
  nganHang,
  taiKhoan,
  setNganHang,
  setTaiKhoan
}) => {
  return (
    <>
      <div className='space-y-2 p-4'>
        <div className='space-y-1'>
          <UnitDropdownV2 formMode={formMode} />

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Ngân hàng
            </Label>
            <SearchField<NganHang>
              type='text'
              name='ma_ngan_hang'
              searchEndpoint={`/${QUERY_KEYS.NGAN_HANG}`}
              searchColumns={nganHangSearchColumns}
              disabled={formMode === 'view'}
              dialogTitle='Danh mục ngân hàng'
              columnDisplay='ma_ngan_hang'
              displayRelatedField='ten_ngan_hang'
              classNameRelatedField='w-full'
              quickCreate={{
                createTitle: 'Thêm mới ngân hàng',
                editTitle: 'Chỉnh sửa ngân hàng',
                key: BANK_QUICK_CREATE_KEY,
                onSaved: setNganHang
              }}
              onRowSelection={setNganHang}
              value={nganHang?.ma_ngan_hang || ''}
              relatedFieldValue={nganHang?.ten_ngan_hang || ''}
              className='w-100'
            />
          </div>

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Mã tài khoản
            </Label>
            <div className='w-[350px]'>
              <FormFieldV2 type='text' name='tknh' disabled={formMode === 'view'} />
            </div>
            {formMode === 'view' && (
              <Button
                className='ml-2 flex h-8 w-8 min-w-8 items-center justify-center p-0'
                variant='outline'
                onClick={event => {
                  event.preventDefault();
                  event.stopPropagation();
                }}
              >
                <AritoIcon icon={127} />
              </Button>
            )}
          </div>

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Số tài khoản
            </Label>
            <div className='w-[350px]'>
              <FormFieldV2 type='text' name='name' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Tên chủ tài khoản
            </Label>
            <div className='w-full'>
              <FormFieldV2 type='text' name='chu_tk' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Chi nhánh
            </Label>
            <div className='w-full'>
              <FormFieldV2 type='text' name='chi_nhanh' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-36 min-w-36' required>
              Tài khoản kế toán
            </Label>
            <SearchField<AccountModel>
              type='text'
              name='account_model'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
              searchColumns={accountSearchColumns}
              disabled={formMode === 'view'}
              dialogTitle='Danh mục tài khoản'
              columnDisplay='code'
              displayRelatedField='name'
              classNameRelatedField='w-full'
              onRowSelection={setTaiKhoan}
              quickCreate={{
                createTitle: 'Thêm mới tài khoản',
                editTitle: 'Chỉnh sửa tài khoản',
                key: ACCOUNT_QUICK_CREATE_KEY,
                onSaved: setTaiKhoan
              }}
              value={taiKhoan?.code || ''}
              relatedFieldValue={taiKhoan?.name || ''}
              className='w-100'
            />
          </div>
        </div>
      </div>
    </>
  );
};
